<template>
  <el-dialog
    custom-class="dialog-Notice"
    title=""
    :show-close="false"
    :visible="value"
    width="510px"
    :before-close="closeDialog"
    :modal-append-to-body="true"
    :append-to-body="true"
  >
    <div>
      <div class="top">
        <img
          class="dialog-notice-img"
          v-if="lang === 'CN'"
          src="@/assets/images/home/dialog-notice-cn.png"
          alt=""
        />
        <img
          class="dialog-notice-img"
          v-else
          src="@/assets/images/home/dialog-notice-en.png"
          alt=""
        />
        <i class="el-icon-close" @click="closeDialog"></i>
      </div>
      <div class="notice-content">
        <div class="title">
          {{
            $lang(
              "根据沙特国家政府要求,26年1月1日开始,所有运输到沙特的包裹必须有国家地址。"
            )
          }}
        </div>
        <div class="list-title">
          {{ $lang("以下为开放平台改造计划及需要客户配合内容:") }}
        </div>
        <div v-for="(item, index) in list" class="list" :key="index">
          <div class="list-item">{{ $lang(item) }}</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "DialogNotice",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [
        "11月1日-11月12日---需要在测试环境完成系统对接以及调试(具体对接方案PPT可跟销售沟通)。",
        "11月12日-12月10日----11月12日极免短地址系统将正式上线,在这期间各位客户需要完成改造并上线系统回传短地址给极兔,进行短地址试跑。",
        "12月10日之后未按照极兔要求完成系统对接的客户将无法给极免下单。"
      ]
    };
  },
  computed: {
    ...mapGetters(["lang"])
  },
  methods: {
    closeDialog() {
      this.$emit("input", false);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .dialog-Notice {
  border-radius: 10px;
  .top {
    position: relative;
    z-index: 1;
  }
  .el-icon-close {
    position: absolute;
    right: 16px;
    top: 18px;
    font-weight: bold;
    font-size: 20px;
    cursor: pointer;
    color: #222222;
    &:hover {
      color: #e60000;
    }
  }
  .dialog-notice-img {
    margin-top: -28px;
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  .notice-content {
    position: relative;
    z-index: 2;
    margin: -16px 30px 0  30px;
    padding-bottom: 30px;
    border-top: 1px solid #d8d8d8;
  }
  .title {
    padding: 12px;
    margin-top: 20px;
    border-radius: 8px;
    background: #fff5f5;
    font-size: 16px;
    line-height: 24px;
    color: #222222;
  }
  .list-title {
    margin-top: 12px;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    color: #222222;
  }
  .list-item {
    margin-left: 22px;
    margin-top: 12px;
    font-size: 14px;
    line-height: 20px;
    color: #666666;
    position: relative;
    &::before {
      content: "";
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #e60000;
      position: absolute;
      left: -22px;
      top: 7px;
    }
  }
}
</style>
